
import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './ButtonsGroup.scss'

const ButtonsGroup = ({ className, items, itemSelected, itemsDisable, callback }) => {
  const classContainer = classNames('btn-group', className)
  return (
    <div className={classContainer}>
      {items.map((item, key) =>
        (<div key={key} className={setItemClass(key, items.length, item.data, itemSelected, itemsDisable)} onClick={() => callback(item.data)}>
          <label>{item.label}</label>
        </div>)
      )}

    </div>
  )

  function setItemClass (i, length, data, isSelected, isDisabled) {
    let ret = 'radio-tab'
    if (i === 0) {
      ret += ' radio-tab_first'
    } else if (i === (length - 1)) {
      ret += ' radio-tab_second'
    } else {
      ret += ' radio-tab_middle'
    }
    if (data === itemSelected) {
      ret += ' is-selected'
    }
    if (itemsDisable.includes(data)) {
      ret += ' is-disabled all_is-disabled_no-opacity'
    }
    return ret
  }
}

ButtonsGroup.defaultProps = {
  itemsDisable: []
}

ButtonsGroup.propTypes = {
  className: PropTypes.string,
  items: PropTypes.array,
  callback: PropTypes.func,
  itemsDisable: PropTypes.array

}

export default ButtonsGroup
